// The single client-side telemetry call: a landing ping (funnel top).
// Everything else is recorded server-side from real game actions.
import { apiFetch } from "./api";
import { isDiscordActivity } from "./discord";

const LAND_SENT_KEY = "annexi_land_sent";

export function sendPageLand() {
  try {
    if (window.sessionStorage.getItem(LAND_SENT_KEY)) return;
    window.sessionStorage.setItem(LAND_SENT_KEY, "1");
  } catch {
    /* fall through — worst case is one extra ping */
  }
  apiFetch("api/telemetry/land", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      discord: isDiscordActivity(),
      path: window.location.pathname,
    }),
  }).catch(() => {});
}
